export enum SdClaimStatusEnum {
    New,
    InProgress,
    Closed,
    WaitingBefore,
    WaitingClose,
}
